import type { FC, SVGProps } from 'react'

export const Copy: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.33333 9.99967H2.66666C2.31304 9.99967 1.9739 9.8592 1.72385 9.60915C1.4738 9.3591 1.33333 9.01996 1.33333 8.66634V2.66634C1.33333 2.31272 1.4738 1.97358 1.72385 1.72353C1.9739 1.47348 2.31304 1.33301 2.66666 1.33301H8.66666C9.02028 1.33301 9.35942 1.47348 9.60947 1.72353C9.85952 1.97358 9.99999 2.31272 9.99999 2.66634V3.33301M7.33333 5.99967H13.3333C14.0697 5.99967 14.6667 6.59663 14.6667 7.33301V13.333C14.6667 14.0694 14.0697 14.6663 13.3333 14.6663H7.33333C6.59695 14.6663 6 14.0694 6 13.333V7.33301C6 6.59663 6.59695 5.99967 7.33333 5.99967Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
